import dayjs from 'dayjs';
import 'dayjs/locale/nb';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React from 'react';
import cl, { type ClassValue } from 'clsx/lite';

dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDate(date?: string, format = 'D. MMM YYYY'): string {
	dayjs.locale('nb');
	const parsedDate: dayjs.Dayjs = dayjs(date);
	return parsedDate.tz('Europe/Oslo').format(format);
}

export const DateComponent = ({
	className,
	date,
	dateTime = date?.toISOString(),
	format,
}: {
	className?: ClassValue;
	date: Date;
	dateTime?: string;
	format?: string;
} | {
	className?: ClassValue;
	date?: Date;
	dateTime: string;
	format?: string;
}): React.JSX.Element => {
	return (
		<time className={cl(className)} dateTime={dateTime}>
			{dateTime ? formatDate(dateTime, format): dateTime}
		</time>
	);
};

